module.exports = __webpack_public_path__ + "img/404.edd5636c.svg";